<template>
  <div>
    <vx-card class="mb-6">
      <infoGrupo :dados="dados"></infoGrupo>
    </vx-card>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/2 w-full">
        <vs-card class="mb-6">
          <div slot="header">
            <h3>Cadastro de Acessório</h3>
          </div>
          <FormAddLista
            :idGrupo="idGrupo"
            :tipo="tipo"
            tipoCadastro="Marca"
            :entidade="entidade"
            :pk="pk"
            @add="atualizaLista(true)"
          ></FormAddLista>
        </vs-card>
      </div>
      <div class="vx-col sm:w-1/2 w-full">
        <vs-card class="mb-6">
          <div slot="header">
            <h3>Listagem de Acessorios</h3>
          </div>
          <ListListas
            :idGrupo="idGrupo"
            :tipo="tipo"
            :novaBusca="novaBusca"
            tipoCadastro="Modelo"
            :entidade="entidade"
            :pk="pk"
            :subjectPermission="subjectPermission"
            @pesquisado="atualizaLista(false)"
          ></ListListas>
        </vs-card>
      </div>
    </div>
  </div>
</template>

<script>
import service from "../../../services";
import infoGrupo from "../../Includes/infoGrupo";
import ListListas from "./../../lists/ListListas";
import FormAddLista from "./../../forms/FormAcessorio";
export default {
  data() {
    return {
      dados: { Grupo_Fipe: {} },
      tipo: "GruposVeiculosAcessorios",
      entidade: "GruposVeiculosAcessorios",
      pk: "idAcessorio",
      novaBusca: false,
      idGrupo: this.$route.params.id,
      subjectPermission: "Grupo de Veículos",
    };
  },
  methods: {
    atualizaLista(valor) {
      this.novaBusca = valor;
    },
    getDadosGrupo() {
      this.$vs.loading();
      service
        .getAll("Grupo", {}, "listOne/" + this.$route.params.id)
        .then((res) => {
          this.dados = res.data[0];
          this.$vs.loading.close();
        })
        .catch((e) => {
          this.$vs.notify({
            position: "top-center",
            title: "Atenção",
            text: e,
            color: "danger",
          });
          this.$vs.loading.close();
        });
    },
  },
  mounted() {
    this.getDadosGrupo();
  },
  components: {
    infoGrupo,
    ListListas,
    FormAddLista,
  },
};
</script>
